export default __webpack_public_path__ + "static/media/studio.4e8c593e.jpg";